import React from "react";
import { Grid } from "@material-ui/core";
import Lottie from "react-lottie";
import loading from "assets/json/loading.json";
import useStyles from "./styles";

const LoadingPage = () => {
	const classes = useStyles();

	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: loading,
		rendererSettings: {
			preserveAspectRatio: "xMidYMid slice"
		}
	};

	return (
		<Grid
			container
			direction="column"
			justifyContent="center"
			alignItems="center"
			className={classes.container}
		>
			<Grid classes={{ root: classes.root }}>
				<Lottie
					options={defaultOptions}
					height={350}
					width={350}
					isStopped={false}
					isPaused={false}
				/>
			</Grid>
		</Grid>
	);
};

export default LoadingPage;
